// extracted by mini-css-extract-plugin
export default {"form":"ProfileForm_form__7OMue","text":"ProfileForm_text__pjJUe","hr":"ProfileForm_hr__twmMc"};